<!--胃镜-->
<script setup>
import { ref,computed, reactive,watch } from "vue";
import { useCrfStore } from "@/stores/crf";
const crfStore = useCrfStore();
import upload from "@/components/upload1.vue";
import check from "./check.vue";
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0

// 定义组件props属性
const props = defineProps({
  formModel: {},
  type: null
});

// console.log(props.formModel.fields)

// 表单对象
const model = reactive(props.formModel);
// model.fields.分型?'':model.fields.分型 = '无'
// console.log(model.fields,"表单对象");
// console.log(model.fields[props.type],"表单对象1");
// 是否进行过胃镜检查
// model.fields[props.type][`是否进行过胃镜检查？`]?'':model.fields[props.type][`是否进行过胃镜检查？`] = '否'

// 分型的问题，默认选择
// model.fields[props.type]["分型"]?'':model.fields[props.type]["分型"] = "无";
// model.fields[props.type]["分型"] == "有"?model.fields[props.type]["分型"] = "无":'';

// watch(()=>model.fields[`${props.type}`]['分型'],(newvalue,oldvalue)=>{
  // console.log(newvalue)
  // if(!newvalue) return
  // if (newvalue[newvalue.length - 1] == '无') {
  //   let length = newvalue.length
  //   for (let index = 0; index < length-1; index++) {
  //     model.fields[`${props.type}`]?.['分型'].shift()
  //   } 
  // }else{
  //   let index = model.fields[`${props.type}`]?.['分型'].indexOf('无')
  //   if(index > -1) model.fields[`${props.type}`]?.['分型'].splice(index,1)
  // }
// })

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};

// const crfStore = useCrfStore();
</script>
<template>
  <template v-if="crfFields">
    <div style="display:flex;">
      <div class="wj_title">
        <h2>胃镜</h2>
      <p>请上传报告，或点击</p>
      <p>检查填写具体指标；</p>
      </div>
     
      <upload :type="props.type" :data="model" name="wj"></upload>
      <check :period="props.type" text="胃镜" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
    </div>
    <el-form-item label="胃镜检查是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['胃镜检查是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['胃镜检查是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'患者是否新增胃镜检查？':'患者是否进行胃镜检查？'" class="redStar">
          <el-radio-group v-model="crfFields['患者是否进行胃镜检查？']">
            <el-radio label="是"></el-radio>
            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="crfFields['患者是否进行胃镜检查？'] == '是'">

            <el-form-item label="曲张" :prop="itemProp('曲张')"  :rules="crfStore.radioRules(`曲张`)" class="redStar">
              <el-radio-group v-model="crfFields['曲张']">
                <el-radio label="有" prop="有"></el-radio>
                <el-radio label="无" prop="无"></el-radio>
                <el-radio label="未测" prop="未测"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="分型"  class="not_redStar pleft" v-if="crfFields['曲张'] == '有'">
              <!-- <el-radio-group v-model="crfFields['分型']" @change="model.fields[props.type]['分型'] == '有'?model.fields[props.type]['分型'] = '':'' ">
                <el-radio v-if="model.fields[props.type]['分型'] =='无'" label="有" prop="有" ></el-radio>
                <el-radio v-if="model.fields[props.type]['分型'] !='无'" label="GOV1" prop="GOV1"></el-radio>
                <el-radio v-if="model.fields[props.type]['分型'] !='无'" label="GOV2" prop="GOV2"></el-radio>
                <el-radio v-if="model.fields[props.type]['分型'] !='无'" label="IGV1" prop="IGV1"></el-radio>
                <el-radio v-if="model.fields[props.type]['分型'] !='无'" label="IGV2" prop="IGV2"></el-radio>
                <el-radio v-if="model.fields[props.type]['分型'] !='无'" label="EV" prop="EV"></el-radio>
                <el-radio label="无" prop="无"></el-radio>
              </el-radio-group> -->

              <!-- <div class="sanjitxt" v-if="crfFields['药物及毒物接触史']?.includes('其他可疑药物')"> -->
                  <el-checkbox-group  v-model="crfFields['分型']">
                      <el-checkbox label="GOV1" :disabled=" /IGV/ig.test(crfFields['分型']?.join())"></el-checkbox>
                      <el-checkbox label="GOV2" :disabled=" /IGV/ig.test(crfFields['分型']?.join())"></el-checkbox>
                      <el-checkbox label="IGV1" :disabled=" /GOV/ig.test(crfFields['分型']?.join())"></el-checkbox>
                      <el-checkbox label="IGV2" :disabled=" /GOV/ig.test(crfFields['分型']?.join())"></el-checkbox>
                      <el-checkbox label="EV" :disabled=" /GOV|IGV/ig.test(crfFields['分型']?.join())"></el-checkbox>
                      <!-- <el-checkbox label="无"></el-checkbox> -->
                  </el-checkbox-group>
              <!-- </div> -->
            
            </el-form-item>



            <el-form-item label="红色征" :prop="itemProp(`红色征`)" :rules="crfStore.radioRules(`红色征`)" class="redStar" v-if="crfFields['曲张'] == '有'">
              <el-radio-group v-model="crfFields['红色征']">
                <el-radio label="有" prop="有"></el-radio>
                <el-radio label="无" prop="无"></el-radio>
                <el-radio label="未测" prop="未测"></el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="内镜治疗史" :prop="itemProp(`内镜治疗史`)" :rules="crfStore.radioRules(`内镜治疗史`)" class="redStar">
              <el-radio-group v-model="crfFields['内镜治疗史']">
                <el-radio label="有" prop="有"></el-radio>
                <el-radio label="无" prop="无"></el-radio>
                <el-radio label="未测" prop="未测"></el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="门脉高压性胃病" :prop="itemProp(`门脉高压性胃病`)" :rules="crfStore.radioRules(`门脉高压性胃病`)" class="redStar">
              <el-radio-group v-model="crfFields['门脉高压性胃病']">
                <el-radio label="有" prop="有"></el-radio>
                <el-radio label="无" prop="无"></el-radio>
                <el-radio label="未测" prop="未测"></el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="消化性溃疡" :prop="itemProp(`消化性溃疡`)" :rules="crfStore.radioRules(`消化性溃疡`)" class="redStar">
              <el-radio-group v-model="crfFields['消化性溃疡']">
                <el-radio label="有" prop="有"></el-radio>
                <el-radio label="无" prop="无"></el-radio>
                <el-radio label="未测" prop="未测"></el-radio>
              </el-radio-group>
            </el-form-item>
        </template>
        </template>

  </template>
</template>

<style lang="scss" scoped>
.wj_title{
  margin-bottom: 10px;
  p{
    margin:0;
    color:rgba(229, 26, 26, 0.8);
    font-size:12px;
  }
}
</style>